import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaletteItem } from '../models/palette-item.model';

export interface SavedStitchCell {
  paletteItemId: string | null;
  type: string;
}

export interface StitchPattern {
  id?: string;
  name: string;
  author?: string;
  width: number;
  height: number;
  grid: SavedStitchCell[]; // flat array
  palette: PaletteItem[];
  dateCreated?: string;
  dateModified?: string;
  thumbnail?: string;
}

@Injectable({ providedIn: 'root' })
export class StitchMakerService {
  private injector = inject(EnvironmentInjector);

  constructor(private db: AngularFireDatabase) {}

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getAllPatterns(): Observable<StitchPattern[]> {
    return this.inCtx(() => this.db.list<StitchPattern>('/stitchPatterns')
      .snapshotChanges()
      .pipe(map(actions => actions.map(a => ({ id: a.key, ...(a.payload.val() as StitchPattern) })))));
  }

  addPattern(pattern: StitchPattern) {
    return this.inCtx(() => this.db.list('/stitchPatterns').push({
      ...pattern,
      dateCreated: new Date().toISOString(),
      dateModified: new Date().toISOString()
    }));
  }

  updatePattern(id: string, pattern: Partial<StitchPattern>) {
    return this.inCtx(() => this.db.object(`/stitchPatterns/${id}`).update({
      ...pattern,
      dateModified: new Date().toISOString()
    }));
  }

  deletePattern(id: string) {
    return this.inCtx(() => this.db.object(`/stitchPatterns/${id}`).remove());
  }
}
